import { Box, Grid2, Typography } from "@mui/material";
import { SUMMARY_TILE_TONES } from "../../../../constants";
import { CrewStatus } from "../../../../enums";
import { UserModel } from "../../../../models";
import { CrewMember, SummaryTileTone } from "../../../../types";

type SummaryCardProps = {
  label: string;
  value: string | number;
  helperText: string;
  tone: SummaryTileTone;
};

const SummaryCard = ({ label, value, helperText, tone }: SummaryCardProps) => (
  <Box
    className="dashboard-tile"
    sx={{
      minHeight: "auto",
      py: 1.5,
      backgroundColor: SUMMARY_TILE_TONES[tone].background,
      borderColor: SUMMARY_TILE_TONES[tone].border,
    }}
  >
    <Typography className="dashboard-metric-label">{label}</Typography>
    <Typography
      className="dashboard-kpi-value"
      sx={{ mt: 0.5, color: SUMMARY_TILE_TONES[tone].value }}
    >
      {value}
    </Typography>
    <Typography className="dashboard-helper-text" sx={{ mt: 0.5 }}>
      {helperText}
    </Typography>
  </Box>
);

type CrewSummaryCardsProps = {
  crew: CrewMember[];
};

export const CrewSummaryCards = ({ crew }: CrewSummaryCardsProps) => {
  const activeCount = crew.filter(
    (member) => UserModel.getCrewDisplayStatus(member) === CrewStatus.Active,
  ).length;
  const onLeaveCount = crew.filter(
    (member) => UserModel.getCrewDisplayStatus(member) === CrewStatus.OnLeave,
  ).length;
  const cards: SummaryCardProps[] = [
    {
      label: "Total Crew",
      value: crew.length,
      helperText: `${activeCount} active`,
      tone: "neutral",
    },
    {
      label: "Active",
      value: activeCount,
      helperText: `${onLeaveCount} on leave`,
      tone: "success",
    },
  ];

  return (
    <Grid2 container spacing={2}>
      {cards.map((card) => (
        <Grid2 key={card.label} size={{ xs: 12, md: 6 }}>
          <SummaryCard {...card} />
        </Grid2>
      ))}
    </Grid2>
  );
};
